import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToastMsg from "components/common/ToastMsg";
import CheckUserApi from "./apihook/CheckUserApi";
import { ImagePaths } from "utils/ImagePath";
import { emailValidation } from "components/common/validation";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const authtoken = sessionStorage.getItem("token");

  const onFinish = (e) => {
    e.preventDefault();
    if (!email) {
      ToastMsg("error", "Registered mail Id is required");
      return;
    }
    if (!emailValidation(null, email)) {
      ToastMsg("error", "Please enter a valid email address");
      return;
    }

    setLoading(true);
    CheckUserApi(
      { email },
      authtoken,
      (data) => {
        setLoading(false);
        ToastMsg("success", data.message);
        navigate("/otpverification", {
          state: { id: data.user_id, email },
        });
      },
      (error) => {
        setLoading(false);
        ToastMsg("error", error);
      }
    );
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-gray-50 font-sans">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2162167863/photo/businessman-in-the-logging-in-using-a-secure-web-page.jpg?s=1024x1024&w=is&k=20&c=Hc1J9SSw49Ekb4iTLfUJd-vL_Cicbl3WMlABp4yBLSE=')]
        bg-cover bg-center opacity-20"
      ></div>
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Card */}
      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo.default}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn">
          {/* Header with Back */}
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow.default}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() => navigate("/")}
            />
            <h2 className="text-lg font-semibold text-gray-800">
              Forgot Password
            </h2>
          </div>
          <p className="text-[13px] text-gray-500 mb-5">
            Enter your registered email ID to receive an OTP.
          </p>

          {/* Form */}
          <form onSubmit={onFinish} className="space-y-4">
            <div>
              <label className="block text-[13px] font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 text-[13px] rounded-lg border border-gray-200 outline-none focus:ring-2 focus:ring-[#04b7b1] transition"
                placeholder="Enter your registered email"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-2 px-4 rounded-lg text-white font-semibold transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#04b7b1] hover:bg-[#04b7b1]/80 focus:ring-2 focus:ring-[#04b7b1] focus:ring-offset-2"
              }`}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
